import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { MeterPointAgreement } from "./meterpointAgreement"
import {
  IMeterPointAgreement,
  IMeterPointAgreementProductDetails,
  ITariffRate,
} from "./meterpointAgreement.types"
import { safeDayjs } from "@/helpers/dateHelper"
import dayjs from "dayjs"
import {
  AgreementDetails,
  TariffRate,
} from "@/api/backofficeRest/generated/model"

export type MeterPointAgreementRaw = AgreementDetails
export type TariffRateRaw = TariffRate

export const MeterPointAgreementParser: IParser<
  IMeterPointAgreement,
  MeterPointAgreementRaw
> = {
  toDomain: (data: MeterPointAgreementRaw) => {
    try {
      const tariffRates: ITariffRate[] = data.productDetails.tariffRates?.map(
        (rate) => ({
          name: rate?.name ?? "",
          rateInPence: rate?.rateInPence ?? 0,
          startHour: rate?.startHour ?? "",
          endHour: rate?.endHour ?? "",
        }),
      )

      const productDetails: IMeterPointAgreementProductDetails = {
        ...data.productDetails,
        requiresSmartCharging:
          data.productDetails.requiresSmartCharging ?? false,
        tariffRates,
        vatRate: data.productDetails.vatRate ?? undefined,
      }

      return new MeterPointAgreement(
        dayjs(data.fromDate),
        data.isCancelled,
        data.juniferAgreementNumber,
        dayjs(data.orderedDate),
        data.type,
        productDetails,
        safeDayjs(data.toDate),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
